import { render } from "./CompSummaryInfo.vue?vue&type=template&id=3c31ddcb&scoped=true"
import script from "./CompSummaryInfo.vue?vue&type=script&lang=js"
export * from "./CompSummaryInfo.vue?vue&type=script&lang=js"

import "./CompSummaryInfo.vue?vue&type=style&index=0&id=3c31ddcb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c31ddcb"]])

export default __exports__